import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import About from "@/sections/About";
import Services from "@/sections/Services";
import Experience from "@/sections/Experience";
import Packages from "@/sections/Packages";
import CTASection from "@/sections/CTASection";
import FAQ from "@/sections/FAQ";

const Home = () => (
  <main data-testid="home-page">
    <Hero />
    <Marquee />
    <About />
    <Services />
    <Experience />
    <Packages />
    <CTASection />
    <FAQ />
  </main>
);

export default Home;
